import omit from 'lodash/omit'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'

import { useLocation, useNavigate } from 'react-router-dom'
import PhishEmailTemplateForm from './PhishEmailTemplateForm'
import usePermissions from '@/hooks/usePermissions'
import Redirect from '@/components/Redirect'

const mapStateToProps = () => ({})

const PhishEmailTemplateEdit = ({ dispatch }) => {
  const { t } = useTranslation()
  const [labelList, setLabelList] = useState([])
  const [extendResponse, setExtendResponse] = useState({})
  const [html, setHtml] = useState('')

  const navigate = useNavigate()
  const { state } = useLocation()
  const { emailTempId, type } = state || {}
  const canModify = usePermissions(
    type === 'system' ? 'emailTempSystem_modify' : 'emailTempPerson_modify',
  )

  const formData = {
    content: html,
    emailTempId,
    labelList,
    ...extendResponse,
  }

  useEffect(() => {
    dispatch({
      type: 'emailTemplate/getEmailTemplateLabelsById',
      payload: { emailTempId },
      successCallback: options => {
        const transformedOptions = options?.map(({ labelId, labelName }) => ({
          id: labelId,
          label: labelName,
        }))
        if (transformedOptions) {
          setLabelList(transformedOptions)
        }
      },
    })

    dispatch({
      type: 'emailTemplate/getEmailTemplateById',
      payload: { emailTempId },
      successCallback: response => {
        const {
          attachementName: responseAttachementName,
          attachmentContent: responseAttachmentContent,
          landingPageAttachment: responseLandingPageAttachment,
          landingPageAttachmentName: responseLandingPageAttachmentName,
          refLandingpage: responseRefLandingpage,
          refLandingpageName: responseRefLandingpageName,
          senderName: responseSenderName,
          senderAddress: responseSenderAddress,
          name: responseName,
          difficulty: responseDifficulty,
          subject: responseSubject,
          content,
        } = response

        setHtml(content)

        let extractResponse = {
          senderName: responseSenderName,
          senderAddress: responseSenderAddress,
          name: responseName,
          difficulty: responseDifficulty,
          subject: responseSubject,
        }

        if (responseAttachementName) {
          const lastIndex = responseAttachementName.lastIndexOf('.')
          if (lastIndex !== -1) {
            const attachementName = responseAttachementName.substring(0, lastIndex)
            const extension = responseAttachementName.substring(lastIndex + 1)
            const landingPageAttachmentId = responseLandingPageAttachment
            const landingPageAttachmentName = responseLandingPageAttachmentName
            const attachmentContent = responseAttachmentContent
            extractResponse = {
              ...extractResponse,
              attachementName,
              extension,
              isAttachement: true,
              landingPageAttachmentId,
              landingPageAttachmentName,
              attachmentContent,
            }
          } else {
            extractResponse = {
              ...extractResponse,
              attachementName: null,
              extension: null,
              isAttachement: false,
              landingPageAttachmentId: null,
              landingPageAttachmentName: null,
              attachmentContent: null,
            }
          }
        } else {
          extractResponse = {
            ...extractResponse,
            attachementName: null,
            extension: null,
            isAttachement: false,
            landingPageAttachmentId: null,
            landingPageAttachmentName: null,
            attachmentContent: null,
          }
        }

        if (responseRefLandingpage) {
          extractResponse = {
            ...extractResponse,
            isRefLandingpage: true,
            refLandingpage: responseRefLandingpage,
            refLandingpageName: responseRefLandingpageName,
          }
        } else {
          extractResponse = {
            ...extractResponse,
            isRefLandingpage: false,
            refLandingpage: null,
            refLandingpageName: null,
          }
        }
        setExtendResponse(extractResponse)
      },
    })
  }, [dispatch, emailTempId])

  const onSubmit = payload => {
    const transformPayload = omit(payload, 'type')

    dispatch({
      type: 'emailTemplate/editEmailTemplate',
      payload: { ...transformPayload, emailTempId },
      successCallback: () => {
        dispatch({
          type: 'app/notify',
          payload: { message: t('messages.email_template_updated'), severity: 'success' },
        })
        navigate(`/phish_template_email/${type || 'system'}`, { replace: true })
      },
    })
  }

  if (!canModify) return <Redirect />

  return <PhishEmailTemplateForm onSubmit={onSubmit} data={formData} type={type} />
}

export default connect(mapStateToProps)(PhishEmailTemplateEdit)
